
import "./NewExpense.css";
import ExpenseForm from "./ExpenseForm";

function NewExpense(props) {

const saveExpenseDataHandler = (enteredExpenseData) => {
    const expenseData = {
        ...enteredExpenseData,
        id: Math.random().toString()
    };
    props.onAddExpense(expenseData);
}

const openAddExpense = () => {
  props.onDisp('show-disp')
}

const closeAddExpense = () => {
  props.onDisp('no-disp')
}

if (props.disp === 'no-disp') {
  return (
    <div className='new-expense'>
    <div className="new-expense__open">
   <button type="submit" onClick={openAddExpense}>Add Expense</button>
  </div>
  </div>
  )
}

  return (
    <div className='new-expense'>
      <ExpenseForm onSaveExpenseData={saveExpenseDataHandler} closeForm={closeAddExpense}/>
    </div>
  );
}

export default NewExpense;
